import {
  determineFullTradeData,
  returnAllTradeDetailsFromGenericParams,
  returnOPLegFormThisTrade,
  returnRPLegFromThisTrade,
} from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { determineCurrencySymbol } from "@/lib/currencySymbolHelper";
import { ExecutionRequestStatus } from "@/lib/interfaces and Enums/ENUMExecutionRequestStatus";
import {
  ExecutionStrategy,
  ISwapTradeFees,
} from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import tradeDataStore from "@/store/tradeDataStore";
import { returnFeeValueFormatted } from "./ExecutionFeeCellRenderer";

export function returnDealtFeeValueToRender(
  params: any,
  thisTrade: ExecutionStrategy,
): number | undefined {
  if (!thisTrade) {
    return;
  }
  const { isOp, isOutright, isLeg, isER } =
    returnAllTradeDetailsFromGenericParams(params);

  const helperObject = {
    params,
    thisTrade,
    isOp,
    isER,
    isOutright,
    isLeg,
  };

  if (isOp) {
    //ER
    // No Return - Only on the ER as an outright.
    if (isLeg || isOutright) {
      const thisOPLeg = returnOPLegFormThisTrade(helperObject);
      if (!thisOPLeg) {
        return;
      }
      if (!thisOPLeg.fees || thisOPLeg.fees.length == 0) {
        return;
      }

      const feeObj = thisOPLeg.fees.find(
        (feeObj: ISwapTradeFees) =>
          feeObj.transactionFeeSide == thisOPLeg.quoteSide,
      );

      // If an RP went to exectued and had a transactionFee - Still show it to the OP even though they are not affirmed the trade.
      if (
        thisOPLeg.statusER &&
        thisOPLeg.statusER == ExecutionRequestStatus.DealtAway
      ) {
        // 0 is a valid entered fee and must still be returned.
        if (feeObj?.transactionFee != null) {
          return feeObj?.transactionFee;
        }
      }
      if (feeObj?.dealtFee != null) {
        return feeObj.dealtFee;
      }
      return;
    }
  } else {
    //RP
    //ER - Only on the ER as an outright.
    const thisRPLeg = returnRPLegFromThisTrade(helperObject);
    if (isLeg || isOutright) {
      if (!thisRPLeg) {
        return;
      }
      if (!thisRPLeg.fees || thisRPLeg.fees.length == 0) {
        return;
      }
      if (thisRPLeg.unwind == "NPV" || thisRPLeg.unwind == "Recoupon") {
        const feeObj = thisRPLeg.fees.find(
          (feeObj: ISwapTradeFees) =>
            feeObj.transactionFeeSide == thisRPLeg.quoteSide,
        );
        if (feeObj?.dealtFee != null) {
          return feeObj.dealtFee;
        }
      }
    }
  }
  return undefined;
}

const DealtFeeCellRenderer = (params: any) => {
  const fullTradeData = determineFullTradeData(params);
  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade =
    currentTradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;
  if (!thisTrade) return null;

  const { isOp, isOutright, isLeg, isER } =
    returnAllTradeDetailsFromGenericParams(params);
  const helperObject = { params, thisTrade, isOp, isER, isOutright, isLeg };
  const thisLeg = isOp
    ? returnOPLegFormThisTrade(helperObject)
    : returnRPLegFromThisTrade(helperObject);

  const currencySymbol = determineCurrencySymbol({
    thisTrade,
    thisLeg,
    isLeg,
    isER,
    isOutright,
  });

  const valueToRender = returnDealtFeeValueToRender(params, thisTrade);

  const formattedValueToRender = returnFeeValueFormatted(valueToRender);

  return (
    <div>
      {formattedValueToRender && `${currencySymbol}${formattedValueToRender}`}
    </div>
  );
};

export default DealtFeeCellRenderer;
